import { DatePicker, Empty, Input, Select, Table, message } from "antd";
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { MakeApiCall } from "../../../../apis";
import InfoVideo from "../../../../components/header-icons";
import Pagination from "../../../../components/pagination";
import { TableLoading } from "../../../../components/table-animation";
import ExportFile from "./export-file";
import { ErrorModal } from "../../../../components/upload-modals";
import { RenderTable } from "../../../../config";
dayjs.extend(quarterOfYear);
const SdTargeting = ({ locationData }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [totalPage, setTotalPage] = useState(0);
  const [tableLoading, setTableLoading] = useState(true);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [sortFilters, setSortFilters] = useState({
    field_name: null,
    sort_by: null,
  });

  const [filters, setFilters] = useState({
    campaign_name: null,
    campaign_status: null,
    start_date: dayjs().startOf("month").format("YYYY-MM-DD"),
    end_date: dayjs().endOf("month").format("YYYY-MM-DD"),
  });

  const CommaAndFloat = (e) => {
    return (e || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const Comma = (e) => {
    return (e || 0).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const columns = [
    {
      title: "ID",
      align: "center",
      render: (_, __, i) => {
        return <span>{(page - 1) * pageSize + 1 + i}</span>;
      },
    },
    {
      title: "Report Date",
      dataIndex: "report_date",
      key: "report_date",
    },
    {
      title: "Campaign Name",
      dataIndex: "campaign_name",
      key: "campaign_name",
    },
    {
      title: "Campaign ID",
      dataIndex: "campaign_id",
      key: "campaign_id",
    },
    {
      title: "Add To Cart",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
      dataIndex: "add_to_cart",
      key: "add_to_cart",
    },
    {
      title: "Add To Cart Clicks",
      align: "right",
      dataIndex: "add_to_cart_clicks",
      key: "add_to_cart_clicks",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Add To Cart Rate (%)",
      dataIndex: "add_to_cart_rate",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
      key: "add_to_cart_rate",
    },
    {
      title: "Add To Cart Views",
      align: "right",
      dataIndex: "add_to_cart_views",
      key: "add_to_cart_views",
      render: (e) => {
        return Comma(e);
      },
    },
    { title: "Ad Group Id", dataIndex: "ad_group_id", key: "ad_group_id" },
    {
      title: "Ad Group Name",
      dataIndex: "ad_group_name",
      key: "ad_group_name",
    },
    {
      title: "Branded Searches",
      dataIndex: "branded_searches",
      align: "right",
      key: "branded_searches",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Branded Searches Clicks",
      align: "right",
      dataIndex: "branded_searches_clicks",
      key: "branded_searches_clicks",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Branded Searches Views",
      align: "right",
      dataIndex: "branded_searches_views",
      key: "branded_searches_views",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Branded Search Rate (%)",
      align: "right",
      dataIndex: "branded_search_rate",
      key: "branded_search_rate",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Campaign Budget Currency Code",
      dataIndex: "campaign_budget_currency_code",
      key: "campaign_budget_currency_code",
    },
    {
      title: "Clicks",
      align: "right",
      dataIndex: "clicks",
      render: (e) => {
        return Comma(e);
      },
      key: "clicks",
    },
    {
      title: "Cost ($)",
      dataIndex: "cost",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
      key: "cost",
    },
    {
      title: "Detail Page Views",
      align: "right",
      dataIndex: "detail_page_views",
      key: "detail_page_views",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Detail Page Views Clicks",
      align: "right",
      dataIndex: "detail_page_views_clicks",
      key: "detail_page_views_clicks",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "e CP Add To Cart (%)",
      align: "right",
      dataIndex: "e_cp_add_to_cart",
      key: "e_cp_add_to_cart",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "ECP Brand Search",
      align: "right",
      dataIndex: "e_cp_brand_search",
      key: "e_cp_brand_search",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Impressions",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
      dataIndex: "impressions",
      key: "impressions",
    },
    {
      title: "Impressions Views",
      align: "right",
      dataIndex: "impressions_views",
      key: "impressions_views",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "New To Brand Purchases",
      dataIndex: "new_to_brand_purchases",
      align: "right",
      key: "new_to_brand_purchases",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "New To Brand Purchases Clicks",
      align: "right",
      dataIndex: "new_to_brand_purchases_clicks",
      key: "new_to_brand_purchases_clicks",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "New To Brand Sales Clicks",
      align: "right",
      dataIndex: "new_to_brand_sales_clicks",
      key: "new_to_brand_sales_clicks",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "New To Brand Units Sold",
      dataIndex: "new_to_brand_units_sold",
      align: "right",
      key: "new_to_brand_units_sold",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "New To Brand Units Sold Clicks",
      dataIndex: "new_to_brand_units_sold_clicks",
      key: "new_to_brand_units_sold_clicks",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Purchases",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
      dataIndex: "purchases",
      key: "purchases",
    },
    {
      title: "Purchases Clicks",
      align: "right",
      dataIndex: "purchases_clicks",
      key: "purchases_clicks",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Purchases Promoted Clicks",
      dataIndex: "purchases_promoted_clicks",
      align: "right",
      key: "purchases_promoted_clicks",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Sales ($)",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
      dataIndex: "sales",
      key: "sales",
    },
    {
      title: "Sales Clicks",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
      dataIndex: "sales_clicks",
      key: "sales_clicks",
    },
    {
      title: "Sales Promoted Clicks",
      dataIndex: "sales_promoted_clicks",
      align: "right",
      key: "sales_promoted_clicks",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Targeting Expression",
      dataIndex: "targeting_expression",
      key: "targeting_expression",
    },
    { title: "Targeting Id", dataIndex: "targeting_id", key: "targeting_id" },
    {
      title: "Targeting Text",
      dataIndex: "targeting_text",
      key: "targeting_text",
    },
    {
      title: "SIP Targeting Type",
      dataIndex: "sip_targeting_type",
      key: "sip_targeting_type",
    },
    { title: "SIP Medium", dataIndex: "sip_medium", key: "sip_medium" },
    {
      title: "SIP Destination",
      dataIndex: "sip_destination",
      key: "sip_destination",
    },
    {
      title: "SIP Destination Url",
      dataIndex: "sip_destination_url",
      key: "sip_destination_url",
    },
    {
      title: "SIP Placement",
      dataIndex: "sip_placement",
      align: "right",
      key: "sip_placement",
    },
    {
      title: "Units Sold",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
      dataIndex: "units_sold",
      key: "units_sold",
    },
    {
      title: "Units Sold Clicks",
      dataIndex: "units_sold_clicks",
      align: "right",
      key: "units_sold_clicks",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Video Complete Views",
      dataIndex: "video_complete_views",
      align: "right",
      key: "video_complete_views",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Ad Keyword Status",
      dataIndex: "ad_keyword_status",
      key: "ad_keyword_status",
    },
    {
      title: "New To Brand Detail Page View Clicks",
      align: "right",
      dataIndex: "new_to_brand_detail_page_view_clicks",
      key: "new_to_brand_detail_page_view_clicks",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "New To Brand Detail Page View Rate (%)",
      dataIndex: "new_to_brand_detail_page_view_rate",
      align: "right",
      key: "new_to_brand_detail_page_view_rate",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "New To Brand Detail Page Views",
      dataIndex: "new_to_brand_detail_page_views",
      align: "right",
      key: "new_to_brand_detail_page_views",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "New To Brand Detail Page View Views",
      dataIndex: "new_to_brand_detail_page_view_views",
      align: "right",
      key: "new_to_brand_detail_page_view_views",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "New To Brand e CP Detail Page View ($)",
      dataIndex: "new_to_brand_ecp_detail_page_view",
      key: "new_to_brand_ecp_detail_page_view",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Marketplace Id",
      dataIndex: "marketplace_id",
      key: "marketplace_id",
    },
    { title: "Marketplace", dataIndex: "marketplace", key: "marketplace" },
  ];

  const getList = async (data) => {
    setTableLoading(true);
    const response = await MakeApiCall(
      `advertising/sd-targeting?page=${data?.page || page || 1}&per-page=${
        data?.pageSize || pageSize
      }&field_name=${data?.field_name || ""}&sort_by=${
        data?.sort_by || ""
      }&campaign_name=${data?.campaign_name || ""}&campaign_status=${
        data?.campaign_status || ""
      }&start_date=${data?.start_date || ""}&end_date=${data?.end_date || ""}`,
      "get",
      null,
      true
    );

    if (response?.status) {
      setList(response?.data?.records || []);
      setTableLoading(false);
      setTotalPage(response?.data?.pagination?.totalCount || 0);
      setLoading(false);
    } else {
      setLoading(false);
      setTotalPage(0);
      setTableLoading(false);
      ErrorModal(response?.message);
    }
  };

  useEffect(() => {
    setLoading(true);
    getList({ ...filters, page: page, pageSize: pageSize, ...sortFilters });
    return () => {};
  }, []);

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  const sortType = {
    descend: "desc",
    ascend: "asc",
  };
  const DefaultSortType = {
    desc: "descend",
    asc: "ascend",
  };
  const PropsFilter = (type) => ({
    defaultSortOrder:
      type === sortFilters?.field_name
        ? DefaultSortType?.[sortFilters?.sort_by]
        : [],
    sorter: () => {},
  });
  const handleChange = (_, __, sorter) => {
    const obj = {
      field_name: sortType?.[sorter?.order] ? sorter?.columnKey : "",
      sort_by: sortType?.[sorter?.order] || "",
    };
    setSortFilters(obj);
    getList({ ...obj, ...filters, page: page, pageSize: pageSize });
  };

  const presetRanges_ = [
    {
      label: "Yesterday",
      value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
    },
    { label: "This Week", value: [dayjs().startOf("week"), dayjs()] },
    {
      label: "This Month",
      value: [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: "Last Month",
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: "This Quarter",
      value: [dayjs().startOf("quarter"), dayjs().endOf("quarter")],
    },
    {
      label: "This Year",
      value: [dayjs().startOf("year"), dayjs().endOf("year")],
    },
    {
      label: "Last Year",
      value: [
        dayjs().subtract(1, "year").startOf("year"),
        dayjs().subtract(1, "year").endOf("year"),
      ],
    },
  ];
  const presetRanges = presetRanges_.map((range) => {
    const start = range.value[0];
    let end = range.value[1];

    // Check if the end date is in the future
    if (end.isAfter(dayjs())) {
      end = dayjs(); // Replace with the current date
    }

    return {
      ...range,
      value: [start, end],
    };
  });
  return (
    <div className="card custom-ui">
      <div className="card-header">
        <div className="card-title">
          Sponsored Display Targeting
          <InfoVideo
            data={locationData}
            title="sd_targeting"
            className={"ms-3"}
          />
          <Input
            onPressEnter={() => {
              getList({
                ...filters,
                ...sortFilters,
                page: page,
                pageSize: pageSize,
              });
            }}
            value={filters?.campaign_name}
            allowClear
            onChange={(e) => {
              setFilters((prev) => {
                if (!e.target.value && prev) {
                  getList({
                    ...{
                      ...prev,
                      campaign_name: e.target.value,
                    },
                    ...sortFilters,
                    page: page,
                    pageSize: pageSize,
                  });
                }
                return {
                  ...prev,
                  campaign_name: e.target.value,
                };
              });
            }}
            placeholder="Campaign Name"
            className="w-175px ms-3"
          />
          <button
            onClick={() => {
              getList({
                ...filters,
                ...sortFilters,
                page: page,
                pageSize: pageSize,
              });
            }}
            className="btn btn-sm ms-3 btn-search"
            style={{ padding: "5px 15px" }}
          >
            <svg
              width={15}
              height={15}
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth={2}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m21 21-2.243-2.247-2.243-2.247" />
              <path d="M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z" />
            </svg>
          </button>
          <Select
            placeholder="Campaign Status"
            className="w-150px ms-3"
            allowClear
            value={filters?.campaign_status}
            onChange={(e) => {
              const obj = {
                ...filters,
                campaign_status: e,
              };
              setFilters(obj);
              getList({
                ...obj,
                page: page,
                pageSize: pageSize,
                ...sortFilters,
              });
            }}
            options={[
              {
                label: "ENABLED",
                value: "ENABLED",
              },
              {
                label: "PAUSED",
                value: "PAUSED",
              },
            ]}
          />
        </div>
        <div className="card-toolbar">
          <DatePicker.RangePicker
            allowClear
            presets={presetRanges}
            value={
              filters?.start_date && filters?.end_date
                ? [
                    dayjs(filters?.start_date, "YYYY-MM-DD"),
                    dayjs(filters?.end_date, "YYYY-MM-DD"),
                  ]
                : []
            }
            onChange={(e) => {
              const obj = {
                ...filters,
                start_date: !e ? null : dayjs(e?.[0])?.format("YYYY-MM-DD"),
                end_date: !e ? null : dayjs(e?.[1])?.format("YYYY-MM-DD"),
              };
              setFilters(obj);
              getList({ ...obj, ...sortFilters });
            }}
            className="w-250px me-3"
            disabledDate={(current) => {
              return current && current > moment().endOf("day");
            }}
          />
          <ExportFile
            paramsBody={{
              source_type: "Data Source",
              record_type: "SD Targeting",
              start_date: filters?.start_date,
              end_date: filters?.end_date,
              param_filter: {
                start_date: filters?.start_date,
                end_date: filters?.end_date,
                campaign_name: filters?.campaign_name,
                campaign_status: filters?.campaign_status,
              },
            }}
            title="SD Targeting"
            hideTooltip={filters?.start_date && filters?.end_date}
            api={`advertising/sd-targeting?start_date=${
              filters?.start_date || ""
            }&end_date=${filters?.end_date || ""}&is_export=1&field_name=${
              sortFilters?.field_name || ""
            }&sort_by=${sortFilters?.sort_by || ""}&campaign_name=${
              filters?.campaign_name || ""
            }&campaign_status=${filters?.campaign_status || ""}`}
          />
        </div>
      </div>
      <div className="card-body  pt-0">
        {loading ? (
          <TableLoading
            id="test-table"
            columns={[1, 2, 3, 4, 5]}
            checkBoxVal={true}
            actions={[1, 2]}
          />
        ) : list?.length === 0 ? (
          <Empty style={{ minHeight: "500px" }} />
        ) : (
          <div className="">
            <Table
              dataSource={list}
              loading={tableLoading}
              fixed={true}
              sticky={{
                offsetHeader: "0px",
              }}
              scroll={{ x: "max-content", y: "calc(100vh - 405px)" }}
              columns={columns?.map((d) => ({
                ...d,
                className: "minWidth-table",
                ...PropsFilter(d?.dataIndex),
                render: (props, row, index) =>
                  RenderTable(props, row, index, d),
              }))}
              pagination={false}
              onChange={handleChange}
              rowClassName={(record, index) => {
                return index % 2 === 0 ? "even-row" : "odd-row";
              }}
              bordered
              size="small"
            />
          </div>
        )}
        <Pagination
          loading={loading}
          pageSize={pageSize}
          page={page}
          totalPage={totalPage}
          onPerPage={(e) => {
            setLoading(true);
            setPageSize(e);
            setPage(1);
            getList({
              page: 1,
              pageSize: e,
              ...sortFilters,
              ...filters,
            });
          }}
          onPageNo={(e) => {
            setLoading(true);
            setPage(e);
            getList({
              page: e,
              pageSize: pageSize,
              ...sortFilters,
              ...filters,
            });
          }}
        />
      </div>
    </div>
  );
};

export default SdTargeting;
